import Avatar from './avatar.vue'
export default Avatar



// WEBPACK FOOTER //
// ./src/components/avatar/index.js